const salesforceFaqsLink = host =>
  host === 'https://www.slimmingworld.co.uk' || host === 'https://www.slimmingworld.ie'
    ? 'https://www.slimmingworld.co.uk/faqs/s/'
    : // Use UTA for all test env
      'https://acc-www.swlabs.digital/faqs/s/';

export default salesforceFaqsLink;
